// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BasketController from "./basket_controller"
application.register("basket", BasketController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import EvCarouselController from "./ev_carousel_controller"
application.register("ev-carousel", EvCarouselController)

import PasskeysLoginController from "./passkeys_login_controller"
application.register("passkeys-login", PasskeysLoginController)

import PasskeysRegisterController from "./passkeys_register_controller"
application.register("passkeys-register", PasskeysRegisterController)

import PasskeysSupportController from "./passkeys_support_controller"
application.register("passkeys-support", PasskeysSupportController)

import PriceEstimatesController from "./price_estimates_controller"
application.register("price-estimates", PriceEstimatesController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import YesNoQuestionController from "./yes_no_question_controller"
application.register("yes-no-question", YesNoQuestionController)
